import * as ActionType from "./types";

const initialState = {
    arEffects: [],
    dialog: false,
    dialogData: null,
};

const arEffectsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.GET_AR_EFFECTS:
            return {
                ...state,
                arEffects: action.payload,
            };

        case ActionType.OPEN_AR_EFFECTS_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };


        case ActionType.CLOSE_AR_EFFECTS_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };
        case ActionType.CREATE_AR_EFFECT:
            const data = [action.payload, ...state.arEffects];
            return {
                ...state,
                arEffects: data,
            };

        case ActionType.UPDATE_AR_EFFECT:

            return {
                ...state,
                arEffects: state.arEffects.map((arEffect) => {
                    if (arEffect._id === action.payload.id) return action.payload.data;
                    else return arEffect;
                }),
            };

        case ActionType.DELETE_AR_EFFECT:
            return {
                ...state,
                arEffects: state.arEffects.filter(
                    (data) => data._id !== action.payload && data
                ),
            };

        default:
            return state;
    }
};

export default arEffectsReducer;